import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

const DietInfoReminderForDietitianBooking = ({ show, dismiss }) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <Modal show={show} onHide={() => dismiss()} centered>
      <Modal.Dialog className="max-w-md">
        <Modal.Header className="border-0 pb-0 text-center d-block">
          <Modal.Title className="d-flex flex-column align-items-center gap-2 fs-5">
            <span>We need you to answer a few more quetions</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center text-base text-muted"></Modal.Body>
        <Modal.Footer className="border-0 d-flex flex-column gap-2">
          <Button
            variant="outline-secondary"
            className="w-100"
            onClick={() => dismiss()}
          >
            Close
          </Button>
          <Button
            variant="danger"
            style={{ backgroundColor: "var(--primarycolor)" }}
            className="w-100 text-white bg-rose-500"
            onClick={() => {
              const from = encodeURIComponent(
                location.pathname + location.search
              );

              history.push(
                `/diet-info/start?from=${from}&skipIntroMessage=true`
              );
            }}
          >
            Update Now
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default DietInfoReminderForDietitianBooking;
